import { render, staticRenderFns } from "./EnvelopamentoProducao.vue?vue&type=template&id=e4748f0e"
import script from "./EnvelopamentoProducao.vue?vue&type=script&lang=js"
export * from "./EnvelopamentoProducao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports